import React, { useEffect } from "react";
import { useLang } from "../i18n/LanguageContext";

export default function Datenschutz() {
  const { t } = useLang();
  useEffect(() => window.scrollTo({ top: 0 }), []);
  return (
    <main className="pt-32 md:pt-40 pb-24 relative z-10" data-testid="datenschutz-page">
      <div className="container-x max-w-3xl">
        <div className="kicker mb-5">Legal</div>
        <h1 className="display text-5xl md:text-7xl mb-3">{t.datenschutz.title}</h1>
        <p className="font-serif italic text-[var(--terracotta)] text-lg mb-12">{t.datenschutz.sub}</p>

        <div className="space-y-10">
          {t.datenschutz.sections.map((s, i) => (
            <section key={i} data-testid={`datenschutz-section-${i}`}>
              <h2 className="display text-2xl md:text-3xl mb-3">{s.h}</h2>
              <p className="text-[15px] leading-relaxed text-[var(--ink-soft)]">{s.p}</p>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}
